import { EventHome } from './EventHome';

export default EventHome;
